module.exports = __webpack_public_path__ + "media/images/app/register/close-22552969d66fbdb3307b38cd60a754ee.svg";